import { render } from "./EditCampagnePage.vue?vue&type=template&id=37433938&ts=true"
import script from "./EditCampagnePage.vue?vue&type=script&lang=ts"
export * from "./EditCampagnePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__